import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link, useParams, Navigate } from "react-router-dom";
import Particle from "../Particle";
import AnimatedSection from "../AnimatedSection";
import { getBlogBySlug } from "../../data/blogs";
import { BsCalendar3, BsClock, BsArrowLeft } from "react-icons/bs";

function renderBlock(block, index) {
  switch (block.type) {
    case "heading":
      return <h2 key={index} className="blog-content-heading">{block.text}</h2>;
    case "paragraph":
      return <p key={index} className="blog-content-paragraph">{block.text}</p>;
    case "list":
      return (
        <ul key={index} className="blog-content-list">
          {block.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      );
    case "code":
      return (
        <pre key={index} className="blog-content-code">
          <code>{block.text}</code>
        </pre>
      );
    case "image":
      return (
        <figure key={index} className="blog-content-image-wrap">
          <img
            src={block.src}
            alt={block.alt || ""}
            className="blog-content-image"
            loading="lazy"
          />
          {block.caption && (
            <figcaption className="blog-content-image-caption">
              {block.caption}
            </figcaption>
          )}
        </figure>
      );
    default:
      return null;
  }
}

function BlogPost() {
  const { slug } = useParams();
  const blog = getBlogBySlug(slug);

  if (!blog) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <Container fluid className="blog-post-section">
      <Particle />
      <Container>
        <Link to="/blog" className="blog-back-link">
          <BsArrowLeft /> Back to Blogs
        </Link>

        <AnimatedSection>
          <div className="blog-post-cover">
            <img
              src={blog.image}
              alt={blog.title}
              className="blog-post-cover-image"
            />
            <div
              className="blog-post-cover-overlay"
              style={{ background: blog.gradient }}
            />
            <div className="blog-post-tags">
              {blog.tags.map((tag) => (
                <span key={tag} className="blog-post-tag">{tag}</span>
              ))}
            </div>
          </div>

          <div className="blog-post-header">
            <h1 className="blog-post-title">{blog.title}</h1>
            <div className="blog-card-meta blog-post-meta">
              <span>
                <BsCalendar3 />{" "}
                {new Date(blog.date).toLocaleDateString("en-US", {
                  month: "long",
                  day: "numeric",
                  year: "numeric",
                })}
              </span>
              <span>
                <BsClock /> {blog.readTime}
              </span>
            </div>
          </div>

          <Row style={{ justifyContent: "center" }}>
            <Col lg={8}>
              <article className="blog-post-content">
                {blog.content.map((block, index) => renderBlock(block, index))}
              </article>
            </Col>
          </Row>
        </AnimatedSection>
      </Container>
    </Container>
  );
}

export default BlogPost;
